/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import {
  SELECTIVELY_RENDER_ANNOTS_FLAG_FOR_MOBILE,
  mobileCommentingTargetMboxId,
  mobileCommentingTargetValue,
  sharedFilesStickyTools
} from "../constants/constants";
import { getFeatureFlagApis } from "../publicApis/featureFlag";
import { getShouldRenderCommentsDropin } from "../selectors/overlayDropinSelectors";

export const enableCommentingOnMobile = async stores => {
  const isCommentingEnabled = getShouldRenderCommentsDropin(stores);
  const isMobileCommentingEnabledPromise = getFeatureFlagApis().getFeatureFlag(mobileCommentingTargetMboxId);
  isMobileCommentingEnabledPromise.then(res => {
    if (res === mobileCommentingTargetValue) {
      stores.stickyToolsStore.setStickyVerbs(sharedFilesStickyTools);
    }
  });
  if (isCommentingEnabled) {
    const isMobileCommentingEnabled = await isMobileCommentingEnabledPromise;
    if (isMobileCommentingEnabled !== mobileCommentingTargetValue) {
      stores.overlayDropinStore.setShouldRenderCommentsDropin(false);
      return SELECTIVELY_RENDER_ANNOTS_FLAG_FOR_MOBILE;
    }
  }
};
